import { createContext, useCallback, useContext, useState } from 'react';

export const ControlResetContext = createContext(0);

export function useControlResetSignal() {
  return useContext(ControlResetContext);
}

export function useResettableControlState(initialValue) {
  const revision = useControlResetSignal();
  const [snapshot, setSnapshot] = useState(() => ({ revision, value: initialValue }));
  const value = snapshot.revision === revision ? snapshot.value : initialValue;

  const setValue = useCallback((nextValueOrUpdater) => {
    setSnapshot((currentSnapshot) => {
      const currentValue = currentSnapshot.revision === revision
        ? currentSnapshot.value
        : initialValue;
      const nextValue = typeof nextValueOrUpdater === 'function'
        ? nextValueOrUpdater(currentValue)
        : nextValueOrUpdater;

      if (currentSnapshot.revision === revision && Object.is(currentValue, nextValue)) {
        return currentSnapshot;
      }
      return { revision, value: nextValue };
    });
  }, [initialValue, revision]);

  return [value, setValue];
}
